// extracted by mini-css-extract-plugin
module.exports = {"grid":"seance-grid_grid__2qHns","minWidth":"seance-grid_minWidth__33mv3"};